import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/home/game_arrow_white.png'


const _hoisted_1 = { class: "details_container" }
const _hoisted_2 = { class: "cards_row" }
const _hoisted_3 = { class: "card1" }
const _hoisted_4 = { style: {"padding":"5px"} }
const _hoisted_5 = { class: "card2" }
const _hoisted_6 = { style: {"padding":"5px"} }
const _hoisted_7 = { class: "card3" }
const _hoisted_8 = { style: {"padding":"5px"} }
const _hoisted_9 = { class: "claim_Container" }
const _hoisted_10 = { class: "claim_card" }
const _hoisted_11 = { style: {"font-size":"15px","font-weight":"600"} }
const _hoisted_12 = { class: "valueText" }
const _hoisted_13 = { class: "amountText" }
const _hoisted_14 = { class: "recievedAmount" }
const _hoisted_15 = { class: "tabel_content" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }

import { onMounted, ref } from 'vue';
import SelectPopOver from './selectPopOver.vue';
import TimeSelector from './timeSelector.vue';
import { getRewardDetail } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { getRewardDetailDataFunc, RewardDetails, DetailsItem, getNextPageDetailsViewDataFunc, callCommissionBalanceClaim, getCommissionBalanceData } from '@/view/agent/supportScript';
import { useUserStore } from '@/stores/user';
import NoDataCustom from '../../components/common/noDataCustom.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'detailsView',
  setup(__props) {

const userStore = useUserStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const detailsList = ref<DetailsItem[]>([])
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const activeType = ref(1)
const selectorRef = ref()
const availabaleCommissionAmount = ref(0)
const recievedCommissionAmount = ref(0)
const uid = ref(userStore.id)
const formatYMD = (date: Date): string => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

const today = new Date();
const date = ref(formatYMD(today));

const rewardData = ref<RewardDetails>({
    summary: {
        commission: 0,
        commissionRate: 0,
        total: 0,
    },
    details: [],
    totalPage: 0
})
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const setDate = (value: any) => {
    date.value = value
    detailsList.value = []
    pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()
}
const setActiveType = (type: any) => {
    detailsList.value = []
    activeType.value = type
     pageNumber.value = 1
    loadingRef.value.open()
    getRewardData()

}
const getNextPageRewardData = () => {
    getNextPageDetailsViewDataFunc(total, pageNumber, getRewardData, loadingRef)
}
const getCommissionBalance = async () => {
    const { data } = await getCommissionBalanceData(uid, loadingRef,)
    availabaleCommissionAmount.value = data?.totalCommission || 0
    recievedCommissionAmount.value = data?.claimedCommission || 0
}

const callCommissionBalanceClaimed = async () => {
    if (availabaleCommissionAmount.value > 0) {
        await callCommissionBalanceClaim(uid, loadingRef, getCommissionBalance, showSuccess, showError)
        pageNumber.value = 1
        total.value = 0
        rewardData.value = {
            summary: {
                commission: 0,
                commissionRate: 0,
                total: 0,
            },
            details: [],
            totalPage: 0
        }
        detailsList.value = []
        getRewardDetailDataFunc(
            getRewardDetail,
            date,
            pageNumber,
            activeType,
            rewardData,
            detailsList,
            total,
            loadingRef,
            showError
        )
    }

}
const getRewardData = () => {
    getRewardDetailDataFunc(
        getRewardDetail,
        date,
        pageNumber,
        activeType,
        rewardData,
        detailsList,
        total,
        loadingRef,
        showError
    )
}
const closeSelector = () => {
    selectorRef.value.close()
}
onMounted(() => {
    loadingRef.value.open()
    getRewardData()
    getCommissionBalance()
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TimeSelector, {
        onGetSelectedDateData: setDate,
        onResetFeild: closeSelector
      }),
      _createVNode(SelectPopOver, {
        ref_key: "selectorRef",
        ref: selectorRef,
        onSetActiveType: setActiveType
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, {
        class: "cards_row_content",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, { span: "8" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createTextVNode("R$ ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(rewardData.value.summary.commission)), 1)
                ]),
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('agent.commission')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "7" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", null, _toDisplayString(rewardData.value.summary.commissionRate) + "%", 1)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('agent.commissionRate')), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "8" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[1] || (_cache[1] = _createTextVNode("R$ ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(rewardData.value.summary.total)), 1)
                ]),
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('agent.totalCommission')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('agent.availableCommission')), 1),
        _createVNode(_component_van_row, { style: {"padding-top":"15px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_van_col, {
              span: "18",
              class: "commissionValue"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('withdraw.value')), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatCurrency)(availabaleCommissionAmount.value)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_van_col, {
              span: "6",
              style: {"padding-left":"2%","display":"flex","align-items":"center"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(availabaleCommissionAmount.value > 0 ? 'enableBtn' : 'disableBtn'),
                  onClick: callCommissionBalanceClaimed
                }, _toDisplayString(_ctx.$t('activity.reciev')), 3)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_14, [
          _createTextVNode(_toDisplayString(_ctx.$t('agent.earningRecieved')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(recievedCommissionAmount.value)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      (activeType.value == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_van_row, { class: "tabel_hed" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "9",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.directPlayer')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.rollover')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "9",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.commission')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "tabel_row",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.fromUid), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "6",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.turnover), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet",
                    style: {"color":"#FBA531"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.coin), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (activeType.value == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_van_row, { class: "tabel_hed" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "9",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.directPlayer')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "5",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.rollover')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "5",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.level')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "5",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('agent.commission')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_row, {
                class: "tabel_row",
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.fromUid), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.turnover), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.level), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, {
                    span: "5",
                    class: "head_alignemnet",
                    style: {"color":"#FBA531"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.coin), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (detailsList.value.length <= 0)
        ? (_openBlock(), _createBlock(NoDataCustom, { key: 2 }))
        : _createCommentVNode("", true),
      (total.value >= pageNumber.value)
        ? (_openBlock(), _createBlock(_component_van_row, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "arrowDown"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "",
                    onClick: getNextPageRewardData
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ], 64))
}
}

})